export default __webpack_public_path__ + "static/media/fifth-section-bg-dkt.abaebaf9.png";